import { ObjectSchema, object, string } from 'yup'

export const validationSchema: ObjectSchema = object({
  projectName: string()
    .trim()
    .required()
    .label('Project Name')
    .required()
    .min(1),
})

export const formFields = [
  {
    type: 'text',
    name: 'projectName',
    label: 'Project Name:',
    className: 'grid-xl-10 grid-start-1',
    required: true,
  },
]
